import React from "react";
import { StyleSheet, Text, View } from "react-native";

export default function ReportEmptyState({ title, description, compact = false }) {
  return (
    <View style={[styles.container, compact && styles.compact]}>
      <Text style={styles.title}>{title}</Text>
      {!!description && <Text style={styles.description}>{description}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: { paddingVertical: 14, paddingHorizontal: 8, alignItems: "center", justifyContent: "center" },
  compact: { paddingVertical: 8 },
  title: { color: "#555555", fontFamily: "Archivo-Bold", fontSize: 11, textAlign: "center" },
  description: { marginTop: 4, color: "#888888", fontFamily: "Archivo-Regular", fontSize: 10, lineHeight: 14, textAlign: "center" },
});